import script from "./RankTeam.vue?vue&type=script&lang=ts&setup=true"
export * from "./RankTeam.vue?vue&type=script&lang=ts&setup=true"

import "./RankTeam.vue?vue&type=style&index=0&id=7367e761&lang=scss"

const __exports__ = script;

export default __exports__